export default __webpack_public_path__ + "static/media/angle-up-regular.78373b88.svg";